import { render, staticRenderFns } from "./Divider2.vue?vue&type=template&id=f7b5d8d8&scoped=true"
import script from "./Divider2.vue?vue&type=script&lang=js"
export * from "./Divider2.vue?vue&type=script&lang=js"
import style0 from "./Divider2.vue?vue&type=style&index=0&id=f7b5d8d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7b5d8d8",
  null
  
)

export default component.exports